export const errorFragment = `
  error {
    message
    error
    statusCode
    internalCode
}
`;
